export default __webpack_public_path__ + "static/media/ImageCompanyAnniversary.f241cfc9.png";